<template>
  <div>
    <list
      row-key="RequirementId"
      ref="list"
      unit="软件需求"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <span style="font-size: 14px;vertical-align: text-top;color: #606266;">文件名称：</span>
        <el-input style="width:220px;" size="mini" v-model="fileName" />
        <el-button style="margin-left:10px;" size="mini" type="primary" @click="exportExl">导 出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="申请人部门">
          <el-input size="mini" v-model="params.DpName" placeholder="请输入申请人部门" clearable />
        </el-form-item>
        <el-form-item label="申请人名称">
          <el-input size="mini" v-model="params.EmpName" placeholder="请输入申请人名称" clearable />
        </el-form-item>
        <el-form-item label="申请类型">
          <apply-type v-model="params.ApplyTypeId" />
        </el-form-item>
        <el-form-item label="申请标题">
          <el-input size="mini" v-model="params.Title" placeholder="请输入申请标题" clearable />
        </el-form-item>
        <el-form-item label="系统名称">
          <system-select v-model="params.SystemId" @select="onSelect" />
        </el-form-item>
        <el-form-item label="模块名称" v-if="params.SystemId">
          <module-select
            ref="moduleSelect"
            :params="{Pid: params.SystemId}"
            v-model="params.ModuleId"
          />
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            size="mini"
            v-model.trim="params.ApplyStartDate"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.ApplyEndDate"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="当前状态">
          <el-checkbox-group v-model="params.StatusList">
            <el-checkbox :label="2">部门审批</el-checkbox>
            <el-checkbox :label="3">IT审核</el-checkbox>
            <el-checkbox :label="4">开发</el-checkbox>
            <el-checkbox :label="6">测试</el-checkbox>
            <el-checkbox :label="7">结束</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="EmpName" label="申请人姓名" />
        <el-table-column prop="DpName" label="申请人部门" />
        <el-table-column prop="ApplyTypeName" label="申请类型" />
        <el-table-column prop="Title" label="申请标题" />
        <el-table-column prop="SystemName" label="系统名称" />
        <el-table-column prop="ModuleName" label="模块名称" />
        <el-table-column label="申请时间">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AddTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StatusText" label="当前状态" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import applyType from "@/components/sys/setting/applyType/select";
import systemSelect from "@/components/sys/setting/sys/select";
import moduleSelect from "@/components/sys/setting/sys/select";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    applyType,
    systemSelect,
    moduleSelect,
    exportDialog,
  },
  data() {
    var today = this.$commonJs.toDateStringByFormat(new Date(), "YYYYMMDD");
    return {
      api: require("@/api/bm/requirement").default,
      params: {
        EmpName: "",
        DpName: "",
        ApplyTypeId: null,
        Title: "",
        SystemId: null,
        ModuleId: null,
        ApplyStartDate: null,
        ApplyEndDate: null,
        StatusList: [3, 4, 6],
      },
      fileName: "软件需求" + today,
    };
  },
  methods: {
    onSelect(data) {
      if (data) {
        this.$nextTick(() => {
          this.params.ModuleId = null;
          this.$refs.moduleSelect.$refs.commonSelect.getData();
        });
      }
    },
    exportExl() {
      if (!this.fileName) {
        this.$message.warning("请先填写文件名");
        return;
      }
      this.$refs.exportDialog.open(this.fileName).then((that) => {
        that.getData(this.params);
      });
    },
  },
};
</script>